import { Columns } from '@shared/interfaces/table/column-config';
import { EstimationGroupDto } from '@app/api/dmc';

export const veeDetailsMasterdata: Columns<EstimationGroupDto>[] = [
  {
    title: 'vee.details.name',
    key: 'name',
  },
  {
    title: 'vee.details.hoursBeforeEstimation',
    key: 'estimateAfter',
  },
  {
    title: 'vee.details.attachedMeteringPoints',
    key: 'meteringPointCount',
  },
  {
    title: 'vee.details.createdBy',
    key: 'createdBy',
  }
];
